import { Flex, Text } from '@chakra-ui/react';
import { IoArrowDownOutline, IoArrowUpOutline } from 'react-icons/io5';
import { Avatar, Icon } from '@chakra-ui/react';
import { useAppSelector } from 'store/hooks';
import { selectAgentStatisticComputed, selectAgentStatisticData, selectAgentStatisticKpis } from 'store/slices/agent';

export type TItem = {
    title: string;
    value: number;
    rate?: {
        value: number | string;
        positive: boolean;
    };
};

const data = {
    calls: 142,
    dds: 19,
    uniqueCalls: 41,
    earlyHangUps: 27,
    sms: 165,
    pickUps: 24,
    convos: 19,
    offers: 10,
    dq: 1,
    sets: 10,
    triage: 1,
    workTime: '05:08:23',
    efficiency: {
        pickUpRate: 16,
        uniquePickUpRate: 100,
        avgDU: 3.4634146341463414,
        convoRate: 79.16666666666666,
        offerRate: 52.63157894736842,
        dqRate: 5.263157894736842,
        setRate: 100,
        convoTime: '02:45:45',
        callTime: '00:08:43.42105263157896',
    },
};

const Statistics = () => {
    const data = useAppSelector(selectAgentStatisticData);

    return (
        <Flex gap="8px" flexWrap="wrap">
            {data.map((item, index) => {
                const color = item?.rate?.positive ? 'green.500' : 'red.500';
                const icon = item?.rate?.positive ? IoArrowUpOutline : IoArrowDownOutline;

                return (
                    <Flex
                        key={index}
                        bgColor="gray.50"
                        padding="16px"
                        flexDirection="column"
                        flex="1 0 130px"
                        borderRadius="8px"
                    >
                        <Text
                            color="gray.500"
                            fontSize="sm"
                            fontWeight="500"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            lineHeight={1}
                        >
                            {item.title}
                            {!!item.rate?.value && <Icon color={color} as={icon} width="16px" height="16px" />}
                        </Text>
                        <Text
                            fontSize="24px"
                            fontWeight="700"
                            letterSpacing="-0.48px"
                            marginTop="20px"
                            mb="16px"
                            color="gray.900"
                            lineHeight={1}
                        >
                            {item.value || 0}
                        </Text>
                        {!!item.rate?.value && (
                            <Text fontSize="sm" fontWeight="600" mt="auto" color={color} lineHeight={1}>
                                {item.rate.value}%
                                <Text as="span" color="gray.500" fontSize="12px" fontWeight="500">
                                    &nbsp;rate
                                </Text>
                            </Text>
                        )}
                    </Flex>
                );
            })}
        </Flex>
    );
};

export default Statistics;
